import { addDays, format } from "date-fns";
import { useMemo, useState } from "react";
import EventCalendarHeaderItem from "./EventCalendarHeaderItem";
import { ProgressSpinner } from "primereact/progressspinner";
import EventCalendarWeeklyItem from "./EventCalendarWeeklyItem";

const EventCalendarWeekly = ({ events, onClick, loading, title }) => {
  const [currentStart] = useState(new Date()); // today

  // Generate 7 days starting from today
  const daysInWeek = [];
  for (let i = 0; i < 7; i++) {
    daysInWeek.push(addDays(currentStart, i));
  }

  // Group events by date
  const eventsByDate = useMemo(() => {
    return events.reduce((acc, event) => {
      const dateKey = format(event.date, "yyyy-MM-dd");
      if (!acc[dateKey]) acc[dateKey] = [];
      acc[dateKey].push(event);
      return acc;
    }, {});
  }, [events]);

  return (
    <div className="col-center-center w-full relative">
      {/* Header */}
      {title && (
        <div className="row-start-center w-full gap-2 pb-2">
          <span className="font-semibold text-sm text-slate-600">{title}</span>
        </div>
      )}

      {/* Weekdays + Date header */}
      <div className="row-start-center w-full">
        {daysInWeek.map((day) => (
          <EventCalendarHeaderItem
            key={format(day, "yyyy-MM-dd")}
            day={format(day, "EEE, dd MMM yy")} // <-- weekday + date
          />
        ))}
      </div>

      {/* Days row */}
      <div className="row-start-start w-full min-h-[5rem] !items-stretch">
        {daysInWeek.map((day) => {
          const dateKey = format(day, "yyyy-MM-dd");
          const todaysEvents = eventsByDate[dateKey] || [];
          return (
            <EventCalendarWeeklyItem
              key={dateKey}
              day={day}
              events={todaysEvents}
              onClick={onClick}
            />
          );
        })}
      </div>

      {/* Loading overlay */}
      {loading && (
        <div className="col-center-center absolute bg-slate-100/50 w-full h-full rounded">
          <ProgressSpinner />
        </div>
      )}
    </div>
  );
};

export default EventCalendarWeekly;
